import cx from 'classnames';
import { type ReactNode } from 'react';
import typography from '~styles/typography.scss';
import styles from './SettingsOutletHeader.scss';

export type SettingsOutletHeaderVariant = 'page' | 'section';

export interface SettingsOutletHeaderProps {
  title: ReactNode;
  subtitle?: ReactNode;
  actions?: ReactNode;
  /** Applied to the heading element (e.g. for `aria-labelledby` on a wrapping `<section>`). */
  titleId?: string;
  /** `section`: general-settings block titles (matches former `.sectionTitle` / `.sectionSubtext`). */
  variant?: SettingsOutletHeaderVariant;
}

export const SettingsOutletHeader = ({
  title,
  subtitle,
  actions,
  titleId,
  variant = 'page',
}: SettingsOutletHeaderProps) => {
  const isSection = variant === 'section';

  const headingClassName = isSection
    ? styles.sectionHeading
    : cx(typography.h4, styles.title);

  const subtitleClassName = isSection
    ? styles.sectionSubtitle
    : styles.subtitle;

  const heading = isSection ? (
    <h3 id={titleId} className={headingClassName}>
      {title}
    </h3>
  ) : (
    <h2 id={titleId} className={headingClassName}>
      {title}
    </h2>
  );

  return (
    <header className={styles.root}>
      <div className={styles.lead}>
        {heading}
        {subtitle ? <div className={subtitleClassName}>{subtitle}</div> : null}
      </div>
      {actions ? <div className={styles.actions}>{actions}</div> : null}
    </header>
  );
};
